"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var prop_types_1 = __importDefault(require("prop-types"));

var Container = styled_components_1.default("button")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  font-family: \"Nunito Sans\", sans-serif;\n  border: none;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 10px 25px\n    ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  transition: all 0.2s ease-in-out;\n  &:hover {\n    opacity: 0.9;\n  }\n  &:active {\n    opacity: 1;\n  }\n"], ["\n  background: none;\n  font-family: \"Nunito Sans\", sans-serif;\n  border: none;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 10px 25px\n    ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  transition: all 0.2s ease-in-out;\n  &:hover {\n    opacity: 0.9;\n  }\n  &:active {\n    opacity: 1;\n  }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  if (props.primaryColor === "primary") {
    return "rgba(45, 78, 245, 0.5)";
  } else if (props.primaryColor === "success") {
    return "rgba(76, 226, 167, 0.5)";
  } else if (props.primaryColor === "error") {
    return "rgba(226, 76, 76, 0.5)";
  } else if (props.primaryColor === "alert") {
    return "rgba(241, 161, 83, 0.5)";
  } else if (props.primaryColor === "dark") {
    return "rgba(2, 32, 71, 0.5)";
  }
}, function (props) {
  if (props.primaryColor === "primary") {
    return "#2D4EF5";
  } else if (props.primaryColor === "success") {
    return "#4CE2A7";
  } else if (props.primaryColor === "error") {
    return "#E24C4C";
  } else if (props.primaryColor === "alert") {
    return "#F1A153";
  } else if (props.primaryColor === "dark") {
    return "#022047";
  }
}, function (props) {
  if (props.edges === "sharp") {
    return "0px";
  } else if (props.edges === "rounded") {
    return "50%";
  } else if (props.edges === "round-sharp") {
    return "3px";
  }
});

exports.IconButton = function (_a) {
  var icon = _a.icon,
      _b = _a.element,
      element = _b === void 0 ? "button" : _b,
      _c = _a.edges,
      edges = _c === void 0 ? "sharp" : _c,
      _d = _a.primaryColor,
      primaryColor = _d === void 0 ? "primary" : _d,
      href = _a.href,
      className = _a.className,
      _e = _a.width,
      width = _e === void 0 ? "50px" : _e,
      _f = _a.height,
      height = _f === void 0 ? "50px" : _f;
  return react_1.default.createElement(Container, {
    className: className,
    edges: edges,
    primaryColor: primaryColor,
    as: element,
    href: href,
    width: width,
    height: height
  }, icon);
};

exports.IconButton.propTypes = {
  icon: prop_types_1.default.any.isRequired,
  element: prop_types_1.default.oneOf(["a", "div", "button"]),
  edges: prop_types_1.default.oneOf(["sharp", "rounded", "round-sharp"]),
  primaryColor: prop_types_1.default.oneOf(["primary", "success", "error", "alert", "dark"]),
  href: prop_types_1.default.string,
  className: prop_types_1.default.string,
  width: prop_types_1.default.string,
  height: prop_types_1.default.string
};
var templateObject_1;